var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Live = OCS.WxBriefing.Live || {};
/**
 * NoticeManager Class
 *
 * This class manages the alerts, updates, and information in the bottom marquee.
 *
 * @module UI
 * @class NoticeManager
 * @constructor
 * @requires Mootools 1.6.0+ http://mootools.net/
 *
 */
OCS.WxBriefing.Classes.NoticeManager = new Class({
    Implements: [OCS.WxBriefing.Classes.SingletonManager],
    manager_name: 'NoticeManager',
    bound_methods: {},
    alert_container: null,
    NEW_ADVISORY_EVENT: "new_advisory_event",
    active_notices: {}, // All active advisories per our preferences and to be displayed on the marquee. This will have an entry for every active zone
    advisory_text_popup: null,
    marquee: null,
    mode: 'normal',
    options: {
        alert_container_id: 'alert_container',
        marquee_ops: {
            'warning_mode': 'warning',
            'watch_mode': 'watch',
            'normal_mode': 'normal',
            'container_id': 'marquee',
            'container_selector': '#marquee',
            'container_data_name': 'marquee',
            run_marquee_ops: {
                duration: 20000,
                direction: 'left',
                duplicated: true,
                pauseOnHover: true
            }
        }
    },
    init: function () {
        OCS.console.debug_text('OCS.WxBriefing.Live.UI.NoticeManager initialized');
        var marquee_el = document.id(this.options.marquee_ops.container_id);
        this.marquee = new OCS.WxBriefing.Classes.Marquee(marquee_el, this.options.marquee_ops);
        this.get_latest_advisories();
        this.populate_advisory_window();
        this.alert_container = OCS.WxBriefing.Functions.get_alert_container();


        this.subscribe_to_advisory_notices();
        this.get_latest_advisories();
    },
    /*
     * 
     * Actions
     * 
     */

    filter_adv_obj_to_user_prefs: function (adv_array, user_ww) {
        var notices = {};
        var mode = '';
        var dataset_obj, ending_time, file, zones, affected_area, color, time_string, text;
        var date = OCS.Functions.get_OCSDateTime();
        adv_array.each(function (adv_key) {
            var adv = OCS.Advisories.Functions.get_adv(adv_key);
            affected_area = [];
            zones = adv.get_zone_ids();
            dataset_obj = adv.get_dataset_obj();
            file = adv.get_file();
            time_string = adv.get_time_string();
            ending_time = adv.get_ending_time();
            color = adv.get_color();
            text = adv.get_text(date.get_end_epoch_time());
            text = String(text).trunc(100, true);
            Object.each(user_ww, function (ww) {
                if (zones.contains(ww.ID) || zones.contains(ww.CID)) {
                    affected_area.combine([ww.NAME]);
                }
            }, this);
            if (affected_area.length && !notices.hasOwnProperty(adv_key)) {
                var adv_class_name = adv.get_advisory_class_name();
                if (adv_class_name === this.options.marquee_ops.warning_mode || mode === '' || (mode !== this.options.marquee_ops.warning_mode && adv_class_name === this.options.marquee_ops.watch_mode)) {
                    mode = adv_class_name;
                }

                notices[adv_key] = {
                    color: String(color).substr(0, 7),
                    adv_id: OCS.Utilities.dots_to_dashes(adv_key),
                    adv_key: adv_key,
                    name: adv.get_name() || "Unknown",
                    ending_time: date.get_display_time_string(ending_time),
                    warning_url: dataset_obj.get_url({}) + file,
                    affected_area: affected_area,
                    class_name: adv_class_name,
                    time_string: time_string
                };
                if(text && text !== '' && text.length) {
                    notices[adv_key].advisory_text = text;
                }
            }
        }.bind(this));
        this.set_mode(mode);
        return notices;
    },
    populate_advisory_window: function () {
        if (this.alert_container) {
            var alerts = [];
            if (Object.keys(this.active_notices).length) {
                alerts = Object.values(this.active_notices);
            }
            this.alert_container.draw(alerts);
            this.alert_container.set_mode(this.get_mode());
        }
    },
    process_latest_advisories: function (adv_data) {
        this.set_active_notices({});
        var data = adv_data.data();
        if (data && data.length) {
            var ww_counties = this.get_users_ww_counties();
            this.set_active_notices(this.filter_adv_obj_to_user_prefs(data, ww_counties));
            if (this.marquee) {
                this.marquee.set_active_notices(this.active_notices);
            }
        }
    },
    subscribe_to_advisory_notices: function () {
        var adv_manager = OCS.Viewer.Functions.get_advisory_manager();
        adv_manager.addEvent('advisory_update', this.get_latest_advisories.bind(this));
        adv_manager.register('notice_manager', {filtered_wfo_ids: OCS.Viewer.Config.advisory_info.filtered_wfo_ids, filter_wfo_ids: true});
    },

    /*
     * 
     * Get / Set Methods
     * 
     */

    get_latest_advisories: function () {
        this.process_latest_advisories(OCS.Viewer.Functions.get_advisory_manager().get_advisories(OCS.Functions.get_OCSDateTime(), 'notice_manager'));
    },
    get_mode: function () {
        return this.mode;
    },
    get_users_ww_counties: function () {
        var ww_counties = Object.values(OCS.User.get_user_preference('ww_counties').split(','));
        if (!ww_counties) {
            ww_counties = [];
        }
        ww_counties.combine([OCS.User.get_user_preference('home_county').toUpperCase()]);
        var pm = OCS.WxBriefing.Functions.get_preferences_manager();
        var ww_county_objs = [];
        ww_counties.each(function (county) {
            var c_obj = pm.translate_id_to_county_obj(county);
            if (c_obj) {
                ww_county_objs.push(c_obj);
            }
        });
        return ww_county_objs;
    },
    set_active_notices: function (notices) {
        this.active_notices = notices;
        this.populate_advisory_window();
    },
    set_mode: function (mode) {
        if (!mode) {
            mode = 'normal';
        }
        if (this.marquee) {
            this.marquee.set_mode(mode);
        }
        var footer = document.id('footer');
        if (footer) {
            footer.removeClass(this.mode).addClass(mode + ' noHighlight');
        }

        this.mode = mode;
    },

    /*
     * 
     * Destroy
     * 
     */
    destroy: function () {
        
        if (this.marquee) {
            this.marquee.destroy();
        }
        if (this.alert_container) {
            this.alert_container.destroy();
            this.alert_container = null;
        }
        this.destroy_manager();
    }
});
